import { useCallback } from "react";
import { useUser } from "@/components/UserProvider";
import { generateMockMatterNotePayload } from "@/lib/data/factories/matter-subitem-payload-factory";
import { useCreateMatterNote } from "@/lib/data/react-query/matters/matter-note";
import { createMultiple } from "./mock-api-utils";

export const useCreateMockMatterNote = () => {
  const { currentUser } = useUser();
  const createNote = useCreateMatterNote();

  const createMockMatterNote = useCallback(
    async (
      matterId: string,
      count = 1,
      overrides: Record<string, unknown> = {},
    ) => {
      return createMultiple(count, () =>
        createNote.mutateAsync({
          ...generateMockMatterNotePayload(matterId, overrides),
          userId: currentUser.id,
        }),
      );
    },
    [createNote, currentUser],
  );

  return {
    createMockMatterNote,
    mutation: createNote,
  };
};
